import { FormikHandlers, FormikState, FormikHelpers } from 'formik';
import React, { ChangeEvent, useCallback } from 'react';

import { TextField } from '../text-field';

type Props = Omit<React.ComponentProps<typeof TextField>, 'value' | 'error' | 'defaultValue' | 'name'> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikHandlers & FormikState<any> & FormikHelpers<any>;
  name: string;
};

const FormikTextField: React.FC<Props> = (props: Props) => {
  const { name, formik, helperText, onChange, ...rest } = props;
  const meta = formik.getFieldMeta(name);

  const formikHandleChange = formik.handleChange;
  const changeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      formikHandleChange(e);
      if (onChange) {
        onChange(e);
      }
    },
    [formikHandleChange, onChange],
  );

  return (
    <TextField
      {...rest}
      name={name}
      value={meta.value ?? ''}
      onChange={changeHandler}
      error={meta.touched && !!meta.error}
      helperText={(meta.touched && meta.error) || helperText}
    />
  );
};

export { FormikTextField };
